import {GatsbyBrowser} from 'gatsby';
import AppProvider from './src/AppProvider';
import React from 'react'; // Conserver absolument cette importation pour éviter les erreurs de compilation

const myWrapRootElement: GatsbyBrowser['wrapRootElement'] = ({element}) => {
  return <AppProvider>{element}</AppProvider>;
};

export default myWrapRootElement;
